import { CopyUrlButton } from '@app/core/list-view/actions/CopyUrlButton';
import { DownloadReportBtn } from '@app/core/reports/components/actions/formik/DownloadReportBtn';
import { ResetReportBtn } from '@app/core/reports/components/actions/formik/ResetReportBtn';
import { VisualizeReportBtn } from '@app/core/reports/components/actions/formik/VisualizeReportBtn';
import { useReportCtx } from '@app/core/reports/report-ctx';
import { auditReports } from '@mi-front/api-clients';
import { Box } from '@mui/material';
import { GipReportCreateModalContainer } from '../../../preview/components/save-report/CreateModalContainer';

export function GipReportFormActions() {
  const ctx = useReportCtx();

  return (
    <Box className="mt-2" sx={{ display: 'flex', justifyContent: 'space-between', gap: 2 }}>
      <Box sx={{ display: 'flex', gap: 1 }}>
        <VisualizeReportBtn />
        <ResetReportBtn />
        {ctx.result && (
          <GipReportCreateModalContainer
            onCreate={async (name, config) => {
              return await auditReports.createGipReport({
                name,
                config,
              });
            }}
          />
        )}
      </Box>
      <Box sx={{ display: 'flex', gap: 1.5 }}>
        <CopyUrlButton />
        {ctx.allowDownload && <DownloadReportBtn />}
      </Box>
    </Box>
  );
}
